<nav class="navbar bg-navbar p-3 w-100" [ngClass]="{'rtl': currentLang === 'ar', 'ltr': currentLang !== 'ar'}">
  <div class="container-fluid d-flex justify-content-between align-items-center flex-wrap header-container">
    <div class="d-flex align-items-center">
      <!-- Sidebar Toggle Button (Mobile only) -->
      <button class="btn d-md-none p-2 mb-1 border-0 bg-icon rounded-circle"
        [ngClass]="{ 'me-2': isLTR, 'me-0': !isLTR }" type="button" (click)="toggleSidebar()">
        <img src="assets/icons/menu.png" width="24px" height="24px" class="menu-icon">
      </button>

      <!-- Logo / Title -->
      <a class="navbar-brand mb-0 d-none d-md-block">
        <h6 class="fs-19 fg-400 text-color" [ngClass]="{ 'mt-2': isLTR, 'mb-0': !isLTR }">
          {{ 'HEADER.WELCOME' | translate }} - {{ user?.firstName }}
        </h6>
      </a>
    </div>
    <!-- Right Side Items -->
    <div class="d-flex justify-content-center align-items-center flex-wrap">

      <!-- Time & Date -->
      <div class="text-muted d-none d-lg-flex align-items-center bg-header-shadow p-2 ms-2 my-0 br-20"
        [attr.dir]="isRTL ? 'rtl' : 'ltr'">
        <div class="time-item">
          <i class="fa-regular fa-calendar fs-16 text-time-icon border-2" [ngClass]="isRTL ? 'ms-2' : 'me-2'"></i>
          <span class="text-time fs-14 fg-400">{{ currentDay }} {{ currentDate }}</span>
        </div>
        <div class="time-item">
          <i class="fa-regular fa-clock fs-16 text-time-icon border-2" [ngClass]="isRTL ? 'ms-2' : 'me-2'"></i>
          <span class="text-time fs-14 fg-400">{{ currentTime }}</span>
        </div>
      </div>


      <!-- Notification -->
      <div class="d-none d-lg-flex notif-dropdown position-relative">
        <button class="btn header-icon-btn notif-btn rounded-circle bg-header-icons border-0 position-relative"
          (click)="toggleNotifDropdown($event)">
          <i class="fa fa-bell text-notif-icon"></i>
          <span *ngIf="unreadCount > 0"
            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
            style="font-size:0.6rem;padding:3px 5px;">
            {{ unreadCount > 99 ? '99+' : unreadCount }}
          </span>
        </button>
        <!-- Notification Dropdown -->
        <div *ngIf="showNotifDropdown"
          class="notif-panel bg-drop-down br-10 border-0 shadow"
          style="position:absolute;top:calc(100% + 8px);right:0;width:340px;max-height:420px;overflow-y:auto;z-index:1050;">
          <div class="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
            <span class="fs-14 fg-600 text-color">{{ 'NOTIFICATIONS.TITLE' | translate }}</span>
            <button *ngIf="unreadCount > 0" class="btn btn-sm btn-link p-0 fs-12 text-primary"
              (click)="markAllNotifsAsRead($event)">
              {{ 'NOTIFICATIONS.MARK_ALL_READ' | translate }}
            </button>
          </div>
          <div *ngIf="notifications.length === 0" class="text-center text-muted py-4 fs-13">
            {{ 'NOTIFICATIONS.EMPTY' | translate }}
          </div>
          <div *ngFor="let n of notifications"
            class="px-3 py-2 border-bottom notif-item"
            [class.notif-unread]="!n.isRead"
            style="cursor:pointer;"
            (click)="markNotifAsRead(n, $event)">
            <div class="d-flex align-items-start gap-2">
              <i class="fa-solid fa-circle-dot mt-1"
                [style.color]="n.isRead ? 'var(--text-muted)' : 'var(--cblue5)'"
                style="font-size:0.5rem;"></i>
              <div class="flex-grow-1">
                <div class="fs-13 fg-500 text-color">{{ n.title }}</div>
                <div class="fs-12 text-muted">{{ n.message }}</div>
                <div class="fs-11 text-muted mt-1">{{ n.createdAt | localizedDate:'short' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Dark Mode -->
      <button class="btn header-icon-btn dark-mode-btn rounded-circle bg-header-icons border-0" (click)="toggleTheme()">
        <i class="text-d-mode-icon fa-solid" [ngClass]="isDark ? 'fa-sun' : 'fa-moon'"></i>
      </button>

      <!-- Age tier (Primaire / Collège / Lycée) -->
      <div class="dropdown">
        <button class="btn header-icon-btn rounded-circle bg-header-icons border-0" type="button"
          data-bs-toggle="dropdown" aria-expanded="false"
          [title]="('AGE_TIER.TITLE' | translate) + ' — ' + (tierLabelKey(ageTierService.currentTier()) | translate)">
          <i class="text-color" [ngClass]="tierIcon(ageTierService.currentTier())"></i>
        </button>
        <ul [ngClass]="{ 'dropdown-menu-end': isLTR, 'dropdown-menu-start': !isLTR, 'rtl-dropdown': !isLTR }"
          class="dropdown-menu bg-drop-down text-color br-10 border-0">
          <li>
            <a class="dropdown-item fs-14 fg-500" (click)="setTier('primaire')"
               [class.active]="ageTierService.currentTier() === 'primaire'">
              <i class="fa-solid fa-puzzle-piece me-2"></i> {{ 'AGE_TIER.PRIMAIRE' | translate }}
            </a>
          </li>
          <li>
            <a class="dropdown-item fs-14 fg-500" (click)="setTier('college')"
               [class.active]="ageTierService.currentTier() === 'college'">
              <i class="fa-solid fa-rocket me-2"></i> {{ 'AGE_TIER.COLLEGE' | translate }}
            </a>
          </li>
          <li>
            <a class="dropdown-item fs-14 fg-500" (click)="setTier('lycee')"
               [class.active]="ageTierService.currentTier() === 'lycee'">
              <i class="fa-solid fa-graduation-cap me-2"></i> {{ 'AGE_TIER.LYCEE' | translate }}
            </a>
          </li>
        </ul>
      </div>

      <!-- Language Dropdown -->
      <div class="dropdown">
        <button class="btn header-icon-btn lang bg-header-icons rounded-circle border-0" type="button"
          data-bs-toggle="dropdown" aria-expanded="false">
          <i class="text-switch-lang fa fa-globe"></i>
        </button>
        <ul [ngClass]="{ 'dropdown-menu-end': isLTR, 'dropdown-menu-start': !isLTR, 'rtl-dropdown': !isLTR }"
          class="dropdown-menu bg-drop-down text-color br-10 border-0">
          <li>
            <a class="dropdown-item fs-14 fg-500" (click)="changeLanguage('ar')">{{ 'HEADER.ARABIC' |
              translate }}</a>
          </li>
          <li>
            <a class="dropdown-item fs-14 fg-500" (click)="changeLanguage('fr')">{{ 'HEADER.FRENCH' |
              translate }}</a>
          </li>
          <li>
            <a class="dropdown-item fs-14 fg-500" (click)="changeLanguage('en')">{{ 'HEADER.ENGLISH' |
              translate }}</a>
          </li>
        </ul>
      </div>

      <!-- User Dropdown -->
      <div class="dropdown avatar-drp me-1" *ngIf="user">
        <button class="btn d-flex align-items-center avatar-btn border-0" type="button" data-bs-toggle="dropdown"
          aria-expanded="false">

          <img [src]="'assets/images/default-user.png'" alt="User Avatar" class="rounded-circle user-avatar" width="32"
            height="32">
          <span class="user-name almarai-regular ms-2 me-2 d-none d-md-inline">
            {{ user?.firstName }}
          </span>


          <!-- Custom arrow icon -->
          <i class="fa-solid fa-chevron-down custom-arrow d-none d-md-inline"></i>

        </button>

        <ul [ngClass]="{ 'dropdown-menu-end': isLTR, 'dropdown-menu-start': !isLTR, 'rtl-dropdown': !isLTR }"
          class="dropdown-menu bg-drop-down text-color br-10 border-0">
          <li>
            <a class="dropdown-item fs-14 fg-500">{{ 'HEADER.PROFILE' | translate }}</a>
          </li>
          <li>
            <button class="dropdown-item fs-14 fg-500" type="button" (click)="logout()">
              {{ 'HEADER.LOGOUT' | translate }}
            </button>
          </li>
        </ul>
      </div>


    </div>
  </div>
</nav>